import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { ApiError } from './lib/api';
import { istunnonPaattymisenKasittelija } from './lib/session';
import './styles.css';

const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({ onError: (error) => istuntoPaattyi(error) }),
  mutationCache: new MutationCache({ onError: (error) => istuntoPaattyi(error) }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000,
      // 401 ei korjaannu uudella yrityksellä; ilman tätä päättynyt istunto
      // huomattaisiin vasta usean sekunnin uusintayritysten jälkeen.
      retry: (failureCount, error) =>
        !(error instanceof ApiError && error.isUnauthenticated) && failureCount < 3,
    },
  },
});
const istuntoPaattyi = istunnonPaattymisenKasittelija(queryClient);

const container = document.getElementById('root');
if (!container) throw new Error('Juurielementtiä #root ei löytynyt.');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
